/** Ícones e avatar da tela do chat (traço único, sem dependência). */
import { useState } from "react";

import { corDoAvatar, iniciais } from "../../services/chat";

export function Ic({ d, size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {d.map((p, i) => <path key={i} d={p} />)}
    </svg>
  );
}
export const ICONE = {
  x: ["M18 6 6 18", "M6 6l12 12"],
  lateral: ["M4 4h16v16H4z", "M14 4v16"],
  telaCheia: ["M4 9V4h5", "M20 9V4h-5", "M4 15v5h5", "M20 15v5h-5"],
  plus: ["M12 5v14", "M5 12h14"],
  clip: ["M21 11.5l-8.5 8.5a5.5 5.5 0 0 1-7.8-7.8l9-9a3.5 3.5 0 0 1 5 5l-9 9a1.5 1.5 0 0 1-2.1-2.1l8.3-8.3"],
  send: ["M12 19V5", "M5 12l7-7 7 7"],
  check: ["M20 6 9 17l-5-5"],
  // A seta de responder é a da dona: cabeça à esquerda, cauda que desce em curva.
  undo: ["M4 11h9a6 6 0 0 1 6 6v0a6 6 0 0 1-1.2 3.6", "M9 6 4 11l5 5"],
  smile: ["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z", "M8.5 14.5a4.5 4.5 0 0 0 7 0", "M9 9.5h.01", "M15 9.5h.01"],
  edit: ["M12 20h9", "M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"],
  trash: ["M3 6h18", "M8 6V4h8v2", "M19 6l-1 14H6L5 6", "M10 11v6", "M14 11v6"],
  info: ["M12 16v-4", "M12 8h.01", "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"],
  back: ["m15 18-6-6 6-6"],
  download: ["M12 3v12", "m7 10 5 5 5-5", "M5 21h14"],
  message: ["M21 12a8 8 0 0 1-8 8H8l-5 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8z"],
  mic: ["M12 15a4 4 0 0 0 4-4V6a4 4 0 0 0-8 0v5a4 4 0 0 0 4 4z", "M19 11a7 7 0 0 1-14 0", "M12 18v3", "M9 21h6"],
  chevL: ["m15 18-6-6 6-6"],
  chevR: ["m9 18 6-6-6-6"],
  mais: ["M5 12h.01", "M12 12h.01", "M19 12h.01"],
  relogio: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M12 6v6l4 2"],
  camera: ["M4 7h3l2-3h6l2 3h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z", "M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"],
  pino: ["M12 17v5", "M5 17h14l-2-4V5H7v8z"],
  sino: ["M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", "M10.3 21a1.9 1.9 0 0 0 3.4 0"],
  engrenagem: ["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"],
  faisca: ["M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"],
  play: ["M7 4v16l13-8z"],
  pausa: ["M7 4h3v16H7z", "M14 4h3v16h-3z"],
};

/**
 * A bolinha da pessoa: a foto de perfil quando tem, senão as iniciais na cor
 * dela. A foto vem num endereço público assinado (o mesmo do Cut, que não tem
 * o login do ERP); se falhar, ficam as iniciais.
 */
export function Avatar({ nome, bot, pequeno, foto }) {
  const [falhou, setFalhou] = useState(null);
  const imageUrl = !bot && foto && falhou !== foto ? foto : "";
  return (
    <span className={`pchat-avatar ${bot ? "bot" : `c${corDoAvatar(nome)}`} ${pequeno ? "pequeno" : ""} ${imageUrl ? "com-foto" : ""}`} aria-hidden="true">
      {imageUrl ? <img src={imageUrl} alt="" draggable={false} loading="lazy" onError={() => setFalhou(foto)} /> : bot ? "V" : iniciais(nome)}
    </span>
  );
}
